import React, { useMemo } from 'react';
import clsx from 'clsx';
import { Trans, useTranslation } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';

import usePage from '$app-web/hooks/use-page';
import TextLink from '$app-web/modules/auth/components/text-link';
import { getIsACT, URLsManager } from '$app-web/utils';

import useStyles from './styles';

import { FontAwesomeIcon } from '$common/fontawesome-pro/react-fontawesome';

const PageForgotPasswordSuccess = () => {
    const { t } = useTranslation();
    const classes = useStyles();

    usePage(t('pdash:activity_password_reset_successful'));
    const isACT = useMemo(() => getIsACT(), []);

    return (
        <>
            <Grid item className={clsx(classes.headIconWrapper, { [classes.actHealthColor]: isACT })}>
                <FontAwesomeIcon icon={['fad', 'envelope']} swapOpacity size="5x" />
            </Grid>
            <Grid item>
                <Typography variant="body1" color="textPrimary" gutterBottom align="center">
                    <Trans t={t} i18nKey="pdash:activity_password_request_email_sent" />
                </Typography>
            </Grid>
            <Grid item>
                <Typography variant="subtitle2" gutterBottom className={classes.backToLoginWrapper}>
                    <TextLink to={URLsManager.to('dashboard:auth:SIGN_IN')} color={isACT ? 'actHealth' : 'default'}>
                        {t('pdash:activity_password_request_back_to_login')}
                    </TextLink>
                </Typography>
            </Grid>
        </>
    );
};

PageForgotPasswordSuccess.propTypes = {};

export default PageForgotPasswordSuccess;
